import React from "react";
import UserNav from "../Shared/UserNav";
import { StartProps } from "./Start";
import { Box, ListItem, ListItemIcon, ListItemText, MenuItem, MenuList, Paper } from "@mui/material";
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates';
import InsightsIcon from '@mui/icons-material/Insights';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import { NavLink, useLocation } from "react-router-dom";
import { ItemButtonActions } from "../Solutions/Buttons";

export type SidebarMenuProps = {
  open: boolean;
  size?: "small"|"medium";
  onToggle: () => void;
}

const Sidebar = (props: StartProps & ItemButtonActions & SidebarMenuProps) => {

  const { pathname } = useLocation();

  return <Box className="bg-white" sx={{flex: 1}}>
    <UserNav {...props} 
             size={props.open ? "medium" : "small"} />

    <MenuList>
      <Item icon={<InsightsIcon />} text={props.open ? "Dashboard" : ""} to="/dashboard" isActive={pathname === "/dashboard"} />
      <Item icon={<AutoFixHighIcon />} text={props.open ? "Lesson creator" : ""} to="/lessons/new" isActive={pathname === "/lessons/new"} />
      <Item icon={<TipsAndUpdatesIcon />} text={props.open ? "Knowledge base" : ""} to="/lessons" isActive={pathname === "/lessons"} />
    </MenuList>
  </Box>
}

const Item = (props: { icon: JSX.Element, text: string, isActive?: boolean, to?: string }) => {

  return <ListItem sx={{py: 0.5}}>
    <Paper elevation={0} className={props.isActive ? "bg-grey" : ""} sx={{background: "transparent", flex: 1, p: 0.5}}>
      <MenuItem component={props.to ? NavLink : Box} to={props.to} disableRipple sx={{[`:hover`]: { backgroundColor: "transparent !important" }}}>
        <ListItemIcon><span className={props.isActive ? "text-primary" : "text-secondary"} style={{lineHeight: 0}}>{props.icon}</span></ListItemIcon>
        <ListItemText><span className="text-primary" style={{fontFamily: "var(--header-font)"}}>{props.text}</span></ListItemText>
      </MenuItem>
    </Paper>
  </ListItem>
}

export default Sidebar;